export const en = {
    access: 'access rights',
    id: 'id',
    'product-name': 'product name'
};
